import { databases } from '../lib/appwrite';
import { ID, Query, Permission, Role } from 'appwrite';

const env = import.meta.env as any;
const DB_ID = env.VITE_APPWRITE_DB_ID as string;
const USERS_COL_ID = env.VITE_APPWRITE_USERS_COLLECTION_ID as string;

export type UserProfileDoc = {
  userId: string;
  email?: string;
  name?: string;
  provider: 'email' | 'anonymous';
  createdAt: string; // ISO
  updatedAt: string; // ISO
};

export const getProfileByUserId = async (userId: string) => {
  const res = await databases.listDocuments(DB_ID, USERS_COL_ID, [
    Query.equal('userId', userId),
  ]);
  return res.documents?.[0] ?? null;
};

export const createProfile = async (doc: UserProfileDoc) => {
  const perms = [
    Permission.read(Role.user(doc.userId)),
    Permission.write(Role.user(doc.userId)),
  ];
  return await databases.createDocument(DB_ID, USERS_COL_ID, ID.unique(), doc, perms);
};

export const updateProfile = async (docId: string, patch: Partial<UserProfileDoc>) => {
  return await databases.updateDocument(DB_ID, USERS_COL_ID, docId, patch);
};

export const ensureProfileForAccount = async (account: any) => {
  if (!DB_ID || !USERS_COL_ID) {
    console.warn('Users collection not configured: set VITE_APPWRITE_DB_ID and VITE_APPWRITE_USERS_COLLECTION_ID');
    return null;
  }
  if (!account || !account.$id) {
    console.warn('No account session; skipping profile creation.');
    return null;
  }
  const now = new Date().toISOString();
  const provider = account?.email ? 'email' : 'anonymous';
  const existing = await getProfileByUserId(account.$id);
  if (existing) {
    return await updateProfile(existing.$id, {
      email: account.email ?? existing.email,
      name: account.name ?? existing.name,
      provider,
      updatedAt: now,
    });
  }
  return await createProfile({
    userId: account.$id,
    email: account.email ?? undefined,
    name: account.name ?? undefined,
    provider,
    createdAt: now,
    updatedAt: now,
  });
};